<template>
<div class="chart_data">
    <div class="nodata_wrap">
        <div class="img_wrap">
            <img src="../../assets/images/commom/nodata-tip.png" alt="">
        </div>
        <p>现在还没有数据哦！</p>
    </div>
</div>
</template>

<script>
export default {
  name: 'chart-data',
  components: {},
  props: {},
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {}
};
</script>

<style lang="scss">
.chart_data {
    width: 100%;
    height: 100%;
    .nodata_wrap {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .img_wrap {
            width: 170px;
            height: 157px;
            img {
                width: 100%;
            }
        }
    }
    p {
        color: #000;
        font-size: 14px;
    }
}
</style>
